import React from 'react';
import { Box, Typography } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import QueryStatsIcon from '@mui/icons-material/QueryStats';

const MarqueeSection = () => {
  const items = [
    {
      text: "Americans pay 320% more for the same prescription drugs",
      icon: <AttachMoneyIcon sx={{ mr: 1 }} />
    },
    {
      text: "U.S. brand-name drug prices are 3–4x higher than in the U.K.",
      icon: <TrendingUpIcon sx={{ mr: 1 }} />
    },
    {
      text: "Americans are 3x more likely to skip medications due to cost",
      icon: <QueryStatsIcon sx={{ mr: 1 }} />
    },
    {
      text: "Insulin costs significantly more in America than the rest of the world",
      icon: <AttachMoneyIcon sx={{ mr: 1 }} />
    }
  ];

  // Double the items to ensure smooth infinite loop
  const marqueeItems = [...items, ...items];

  return (
    <Box
      sx={{
        backgroundColor: '#43c5b9',
        py: 2,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
      }}
    >
      <style>
        {`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}
      </style>
      <Box
        sx={{
          display: 'flex',
          animation: 'scroll 40s linear infinite',
          '&:hover': {
            animationPlayState: 'paused'
          }
        }}
      >
        {marqueeItems.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              mx: 4,
              color: 'white',
            }}
          >
            {item.icon}
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                fontSize: { xs: '14px', md: '16px' },
                fontFamily: 'inherit'
              }}
            >
              {item.text}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default MarqueeSection;
